// extracted by mini-css-extract-plugin
module.exports = {"root":"languageSelect_root__3XPec"};